import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../../common/form';
import toastService from '../../../services/toastService';

class ExecutiveSummaryForm extends Form {
	state = {
		data: {
			executiveSummary: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	static propTypes = {
		initialSummary: PropTypes.string,
		onProceed: PropTypes.func,
	};

	schema = {
		executiveSummary: Joi.string().min(5).required().label('Executive Summary'),
	};

	doSubmit = (): void => {
		this.props.onProceed(this.state.data.executiveSummary);

		toastService.success('Executive summary updated successfully!.');
	};

	componentDidMount() {
		if (this.props.initialSummary) {
			this.setState({ data: { executiveSummary: this.props.initialSummary } });
		}
	}

	componentDidUpdate(previousProps: { initialSummary: string; }) {
		if (previousProps.initialSummary !== this.props.initialSummary) {
			this.setState({
				data: { executiveSummary: this.props.initialSummary },
			});
		}
	}

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				{this.renderTextEditor({
					name: 'executiveSummary',
					label: 'Executive Summary',
					placeholder: 'Enter Executive Summary',
				})}

				<div className="divider my-4"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Save Executive Summary')}
				</div>
			</form>
		);
	}
}

export default ExecutiveSummaryForm;
